import { Controller } from '@hotwired/stimulus'

export default class TwoFactorController extends Controller {
  static targets = ['submitButton', 'input', 'resendCodeButton', 'countdown'];

  static values = { timestamp: Number };

  initialize() {
    this.nextAttemptAvailableAt = new Date(this.timestampValue * 1000);
  }

  handleCountdownComplete() {
    this.countdownTarget.innerText = '';
    this.resendCodeButtonTarget.classList.remove('text-gray');
    this.resendCodeButtonTarget.classList.add('text-primary');
    this.resendCodeButtonTarget.disabled = false;
  }

  updateSubmitButton(event) {
    this._updateSubmitButtonState();
  }

  _updateSubmitButtonState() {
    const allInputsFilled = this.inputTargets.every((input) => input.value.trim() !== '');
    this.submitButtonTarget.disabled = !allInputsFilled;
  }
}
